import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next'
import ResultList from './ResultList';
import Pagination from "react-js-pagination";
import Select, { components } from 'react-dropdown-select';
import { isMobile } from "react-device-detect";

const defaultpage = 1
const defaultpageperitem = 10
const defaultvalue = ''

const Results = (props) => {
    /* Assign Variable for Pagination */
    const [currentPage, setCurrentPage] = useState(defaultpage)
    //Navigate to the page
    const paginate = (pageNumber) => {
        setPagination({
            ...pagination,
            currentPage: pageNumber
        })
        props.paginate(pageNumber)
    }

    const [resultdata, setResultdata] = useState({
        results: [],
        paginatedata: {},
        searchtext: ''
    })
    const [pagination, setPagination] = useState()
    const [pagesize, setPagesize] = useState({
        optionvalue: '',
        placeholder: ''
    })
    const [ddstate, setDdstate] = useState('dclose')
    const [showFilterBlk, setShowFilterBlk] = useState(false)

    useEffect(() => {
        let pageperitem = sessionStorage.getItem('pageperitem') ? sessionStorage.getItem('pageperitem') : props.paginatedata.itemsPerPage
        let placeholder = props.pageSize && props.pageSize !== null && props.pageSize.map(data => parseInt(data.fields.key.value) === parseInt(pageperitem) && data.fields.name.value)
        let optionvalue = props.pageSize && props.pageSize !== null && props.pageSize.map(data => ({ value: data.fields.key.value, label: data.fields.name.value }))

        setPagesize({
            optionvalue: optionvalue,
            placeholder: placeholder.filter(res => res !== false && res)
        })
    }, [])

    useEffect(() => {
        let searchtext = props.resultData && props.searchtext
        let datas = props.resultData && props.resultData
        let pagination = props.paginatedata && props.paginatedata
        datas !== undefined && datas !== null && datas !== '' &&
            pagination !== undefined && pagination !== null && pagination !== '' && updateData(datas, pagination, searchtext)
        return updateData(datas, pagination, searchtext)
    }, [props.resultData])

    useEffect(() => {
        let filterlist = props.filters && props.filters.map(data => data.filterItems.filter(item => item.filterItemIsSelected !== false))
        let itemlist = filterlist.filter(list => list.length !== 0)
        itemlist.length > 0 ? setShowFilterBlk(true) : setShowFilterBlk(false)
    }, [props.filters])

    const updateData = (datas, pagination, searchtext) => {
        setResultdata({
            results: datas,
            totalCount: pagination.totalCount,
            itemsPerPage: pagination.itemsPerPage,
            numberOfPages: pagination.numberOfPages,
            currentPage: pagination.currentPage,
            searchtext: searchtext
        })
        let pageperitem = sessionStorage.getItem('pageperitem') ? sessionStorage.getItem('pageperitem') : props.paginatedata.itemsPerPage
        let placeholder = props.pageSize && props.pageSize !== null && props.pageSize.map(data => parseInt(data.fields.key.value) === parseInt(pageperitem) && data.fields.name.value)
        let optionvalue = props.pageSize && props.pageSize !== null && props.pageSize.map(data => ({ value: data.fields.key.value, label: data.fields.name.value }))
        setPagesize({
            optionvalue: optionvalue,
            placeholder: placeholder.filter(res => res !== false && res)
        })
    }

    const onChange = (result) => {
        props.itemsperpage(result[0].value)
        sessionStorage.setItem("pageperitem", result[0].value);
    }

    const clearallfilter = () => {
        props.clearallfilter([])
    }

    const clearFilter = (item) => {
        props.clearfilteritem(item)

        const clearFilteredValue = localStorage.getItem("clearedFilterValue")
        clearFilteredValue ? localStorage.setItem("clearedFilterValue", clearFilteredValue + '|' + item.filterItemID)
            : localStorage.setItem("clearedFilterValue", item.filterItemID)
    }

    const { t } = props;

    return (
        resultdata.totalCount > 0 &&
        <div className="searchresult searchresult-recipefinder">
            {
                showFilterBlk &&
                <div className="filterblock">
                    {
                        props.filters.map(
                            data =>
                                data.filterItems.map(
                                    (item, i) => item.filterItemIsSelected &&
                                        <span className="filterby" key={i} onClick={() => clearFilter(item)}>
                                            {item.filterItemName}
                                            <i className="fa fa-times" />
                                        </span>
                                )
                        )
                    }
                    <a href='' className="clearbtn" onClick={() => clearallfilter()}>clear all</a>
                </div>
            }
            <div className="countercontainer">
                <h3>
                    {
                        resultdata.searchtext === '' ?
                            t('RecipeFinder_NoOfResultsFilter').replace('{0}', resultdata.totalCount) :
                            `${(t('RecipeFinder_NoOfResultKeyword').replace('{0}', resultdata.totalCount)).replace('{1}', `'${resultdata.searchtext}'`)}`
                    }
                </h3>
            </div>
            {
                resultdata.results.map((data, index) => (
                    <ResultList
                        key={index}
                        data={data}
                    />
                )
                )
            }
            <div className="paginate-blk">
                <Select
                    className={ddstate}
                    onChange={onChange}
                    placeholder={pagesize.placeholder}
                    options={pagesize.optionvalue}
                    separator={false}
                    dropdownHandle={false}
                    onDropdownOpen={() => setDdstate('dopen')}
                    onDropdownClose={() => setDdstate('dclose')}
                    dropdownPosition="auto"
                />
                {
                    resultdata.totalCount > resultdata.itemsPerPage &&
                    <Pagination
                        hideFirstLastPages
                        hideDisabled
                        activePage={resultdata.currentPage}
                        itemsCountPerPage={parseInt(resultdata.itemsPerPage)}
                        totalItemsCount={resultdata.totalCount}
                        pageRangeDisplayed={isMobile ? 3 : 4}
                        onChange={paginate}
                        prevPageText={<i className="fa fa-angle-left" aria-hidden="true"></i>}
                        nextPageText={<i className="fa fa-angle-right" aria-hidden="true"></i>}
                    />
                }
            </div>
        </div>
    )
};

export default withTranslation()(Results);
